<template>
  <div>
    <section class="homepg-sec">
      <div class="container">
        <div class="home-headLogo">
          <img src="/images/logo.png" alt="logo" />
          <p>The only resource you need for MLA</p>
        </div>
      </div>
    </section>

    <section class="homepg-card-sec">
      <div class="container">
        <div class="row">
          <div class="card-container">
            <div
              v-for="(card, index) in cards"
              :key="index"
              class="homemock-card"
              data-aos="fade-up"
              :data-aos-delay="index * 100"
              data-aos-duration="800"
            >
              <div class="cardtop-content">
                <img :src="card.image" alt="Card Image" />
                <h2>{{ card.title }}</h2>
                <h6>{{ card.price }}</h6>
              </div>
              <div class="cardbottem-content">
                <h4>{{ card.question }}</h4>
                <p>{{ card.description }}</p>
                <div class="cardbottom-shadow">
                  <img src="/images/cardshadow.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="login-signup-sec">
      <div class="container">
        <div class="loginSignup-btn">
          <button class="loginBtn" @click="openLogin">Login</button>
          <button class="signupBtn" @click="openSignup">Sign up</button>
        </div>
      </div>
    </section>

    <div v-if="paymentReturnMessage" class="payment-return-banner" :class="paymentReturnType">
      {{ paymentReturnMessage }}
    </div>

    <LoginModal
      v-if="showLoginModal"
      @close="showLoginModal = false"
      @open-signup="switchToSignup"
    />
    <SignupModal
      v-if="showSignupModal"
      @close="closeSignup"
      @open-login="switchToLogin"
      @continue="onSignupContinue"
    />
    <MembershipModal
      v-if="showMembershipModal"
      :signup-data="pendingSignup"
      @close="closeMembership"
      @back="backToSignup"
      @selected="onMembershipSelected"
    />
    <PaymentModal
      v-if="showPaymentModal"
      :signup-data="pendingSignup"
      :membership="selectedMembership"
      @close="closePayment"
      @back="backToMembership"
    />
  </div>
</template>

<script>
import axios from 'axios'
import LoginModal from '@/components/LoginModal.vue'
import SignupModal from '@/components/SignupModal.vue'
import MembershipModal from '@/components/MembershipModal.vue'
import PaymentModal from '@/components/PaymentModal.vue'
import {
  clearPendingSignup,
  loadPendingSignup,
  pendingSignupToFormData,
} from '@/views/lib/pendingSignup'

export default {
  name: 'HomePage',
  components: {
    LoginModal,
    SignupModal,
    MembershipModal,
    PaymentModal,
  },
  data() {
    return {
      showLoginModal: false,
      showSignupModal: false,
      showMembershipModal: false,
      showPaymentModal: false,
      pendingSignup: null,
      selectedMembership: null,
      paymentReturnMessage: '',
      paymentReturnType: 'success',
      completingRegistration: false,
      cards: [
        {
          title: 'Questions',
          price: '£9.99/mo.',
          question: 'Practice questions',
          description: '3800 questions based on the MLA content map.',
          image: '/images/questionmark.png',
        },
        {
          title: 'Notes',
          price: '£9.99/mo.',
          question: 'Read notes',
          description: 'Notes the visual aids for all MLA content map conditions',
          image: '/images/file.png',
        },
        {
          title: 'Mocks',
          price: '£9.99/mo.',
          question: 'Test yourself',
          description: 'Five mocks carefully designed to mirror the MLA',
          image: '/images/brain.png',
        },
        {
          title: 'All in one',
          price: '£19.99/mo.',
          question: 'Get all in one',
          description:
            'Get all three products candidates who choose this highest chance of passinh the MLA',
          image: '/images/bag.png',
        },
      ],
    }
  },
  created() {
    this.handleRouteQuery()
  },
  watch: {
    '$route.query': {
      deep: true,
      handler() {
        this.handleRouteQuery()
      },
    },
  },
  methods: {
    handleRouteQuery() {
      const { polar, checkout_id: checkoutId, open } = this.$route.query

      if (polar === 'success' && checkoutId && !this.completingRegistration) {
        this.completeRegistrationAfterPayment(String(checkoutId))
        return
      }

      if (open === 'signup') this.openSignup()
      if (open === 'login') this.openLogin()
    },
    async completeRegistrationAfterPayment(checkoutId) {
      this.completingRegistration = true
      this.paymentReturnMessage = 'Confirming payment and creating your account...'
      this.paymentReturnType = 'success'

      const pending = loadPendingSignup()
      if (!pending) {
        this.paymentReturnMessage =
          'Payment received, but signup details were lost. Please sign up again and contact support if you were charged.'
        this.paymentReturnType = 'error'
        this.clearPolarQuery()
        this.completingRegistration = false
        return
      }

      // const baseUrl = 'http://127.0.0.1:8000/api'
      // const baseUrl = 'https://dev.imsynapse.com/api'
      // const baseUrl = 'https://admin.imsynapse.com/api'
      const baseUrl = 'https://admin.uksynapse.com/api'

      try {
        const formData = pendingSignupToFormData(pending, checkoutId)
        await axios.post(`${baseUrl}/register`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        clearPendingSignup()
        this.pendingSignup = null
        this.selectedMembership = null
        this.paymentReturnMessage = 'Registration successful! You can now log in.'
        this.paymentReturnType = 'success'
        this.clearPolarQuery()
        this.$nextTick(() => {
          this.showLoginModal = true
        })
      } catch (error) {
        this.paymentReturnMessage =
          error.response?.data?.message ||
          'Payment succeeded but account creation failed. Please contact support.'
        this.paymentReturnType = 'error'
        this.clearPolarQuery()
      } finally {
        this.completingRegistration = false
      }
    },
    openLogin() {
      this.showSignupModal = false
      this.showMembershipModal = false
      this.showPaymentModal = false
      this.showLoginModal = true
    },
    openSignup() {
      this.showLoginModal = false
      this.showMembershipModal = false
      this.showPaymentModal = false
      this.showSignupModal = true
    },
    switchToSignup() {
      this.showLoginModal = false
      this.$nextTick(() => {
        this.showSignupModal = true
      })
    },
    switchToLogin() {
      this.showSignupModal = false
      this.$nextTick(() => {
        this.showLoginModal = true
      })
    },
    onSignupContinue(formData) {
      this.pendingSignup = formData
      this.showSignupModal = false
      this.$nextTick(() => {
        this.showMembershipModal = true
      })
    },
    onMembershipSelected(membership) {
      this.selectedMembership = membership
      this.showMembershipModal = false
      this.$nextTick(() => {
        this.showPaymentModal = true
      })
    },
    backToSignup() {
      this.showMembershipModal = false
      this.$nextTick(() => {
        this.showSignupModal = true
      })
    },
    backToMembership() {
      this.showPaymentModal = false
      this.$nextTick(() => {
        this.showMembershipModal = true
      })
    },
    closeSignup() {
      this.showSignupModal = false
      this.clearOpenQuery()
    },
    closeMembership() {
      this.showMembershipModal = false
      this.pendingSignup = null
      this.selectedMembership = null
      this.clearOpenQuery()
    },
    closePayment() {
      this.showPaymentModal = false
      this.clearOpenQuery()
    },
    clearOpenQuery() {
      if (this.$route.query.open) {
        this.$router.replace({ path: '/', query: {} }).catch(() => {})
      }
    },
    clearPolarQuery() {
      const query = { ...this.$route.query }
      delete query.polar
      delete query.checkout_id
      this.$router.replace({ path: '/', query }).catch(() => {})
    },
  },
}
</script>

<style scoped>
.main-content {
  flex: 1;
  height: 90vh;
}

.payment-return-banner {
  position: fixed;
  left: 50%;
  top: 18px;
  transform: translateX(-50%);
  z-index: 1200;
  max-width: min(520px, calc(100vw - 24px));
  padding: 12px 16px;
  border-radius: 12px;
  font-size: 13px;
  text-align: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.payment-return-banner.success {
  background: #e8f5e9;
  color: #2e7d32;
}

.payment-return-banner.error {
  background: #ffebee;
  color: #c62828;
}
</style>
